import React from 'react';

import { AddLabelIcon } from '@/components/icons/svgs';

import { toRgba } from '@/shared/utils/color';

import { cn } from '@/lib/utils';

interface Props {
	labels: { label: string; color: string }[];
	className?: string;
	maxLabelWidth?: number;
	withoutIcon?: boolean;
	startingContent?: React.ReactNode;
	small?: boolean;
}

const BG_ALPHA = 0.18;
function AssignedLabels({
	labels,
	className,
	maxLabelWidth,
	withoutIcon,
	startingContent,
	small = false,
}: Props) {
	return labels.length > 0 || startingContent ? (
		<div
			className={cn('flex max-w-full flex-wrap items-center', small ? 'gap-1' : 'gap-2', className)}
		>
			{startingContent}
			{labels?.map((label, index) => {
				const backgroundColor = label.color ? toRgba(label.color, BG_ALPHA) : 'transparent';

				return (
					<div
						key={index}
						className={cn(
							'flex flex-shrink-0 cursor-default items-center gap-1 rounded-md px-2 py-0.5 text-primary',
							small ? 'text-[11px]' : 'text-[13px]'
						)}
						style={{
							backgroundColor: backgroundColor || 'rgba(0, 0, 0, 0.1)',
						}}
					>
						{!withoutIcon && (
							<AddLabelIcon className={cn('flex-shrink-0', small ? 'h-2.5 w-2.5' : 'h-3 w-3')} />
						)}
						<span
							className={cn(
								'truncate',
								small ? 'max-w-[100px]' : 'max-w-[160px]',
								maxLabelWidth && `max-w-[${maxLabelWidth}px]`
							)}
						>
							{label.label}
						</span>
					</div>
				);
			})}
		</div>
	) : null;
}

export default AssignedLabels;
